import { Box, Button } from '@mui/material'
import React, { useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { AiFillEdit } from "react-icons/ai";
import { MdDelete } from "react-icons/md";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import ExcelExportToolbar from './ExcelExportToolbar';
import { getExtraReportColumns } from './extraReportColumns';
import { FaEye } from "react-icons/fa";
import Tesekkur_View from '../modals/Tesekkur_View';
import { MdEdit } from "react-icons/md";
import ActionType_Modal from '../modals/ActionType_Modal';
import { MdDeleteForever } from "react-icons/md";
import Delete_Modal from '../modals/Delete_Modal';


const Tesekkur_Table = ({ tesekkur, handleOpen_tesekkur, handleClose_tesekkur, open_tesekkur, handleOpen_action, handleClose_action, open_action, handleOpen_delete, handleClose_delete, open_delete, showExtra = false }) => {



  const [info, setInfo] = useState({
    name: "",
    surname: "",
    phone: "",
    email: "",
    topic: "",
    detail: "",
    datetime: "",
    actionType: "",
    actionResult: "",
    location: "",

  })

  const defaultColumns = useMemo(() => [
    { field: "id", headerName: "ID", minWidth: 150, headerAlign: "center", align: "center", flex: 1, disableExport: true },
    {
      field: "actions",
      headerName: "Aksiyon",
      minWidth: 120,
      headerAlign: "center",
      align: "center",
      flex: 1,
      disableExport: true,
      renderCell: ({ id, row: { name, surname, phone, email, topic, detail, datetime, actionType, actionResult, location } }) => [
        <GridActionsCellItem
          key="edit"
          label="Edit"
          icon={<MdEdit size={23} style={{ cursor: 'pointer', color: '#E8C872' }} onClick={() => { handleOpen_action(); setInfo({ id, name, surname, phone, email, topic, detail, datetime, actionType, actionResult, location, type: "tesekkur" }) }} />}
        />
      ],
    },
    { field: "name", headerName: "İsim", minWidth: 150, headerAlign: "center", align: "center", flex: 1 },
    { field: "surname", headerName: "Soyisim", minWidth: 150, headerAlign: "center", align: "center", flex: 1 },
    { field: "email", headerName: "Email", minWidth: 150, headerAlign: "center", align: "center", flex: 1 },
    { field: "phone", headerName: "Telefon", minWidth: 150, headerAlign: "center", align: "center", flex: 1 },
    { field: "location", headerName: "Lokasyon", minWidth: 150, headerAlign: "center", align: "center", flex: 1 },
    { field: "detail", headerName: "Detay", minWidth: 150, headerAlign: "center", align: "center", flex: 1 },
    { field: "datetime", headerName: "Tarih", minWidth: 150, headerAlign: "center", align: "center", flex: 1 },
    { field: "actionType", headerName: "Aksiyon Tipi", minWidth: 150, headerAlign: "center", align: "center", flex: 1 },
    { field: "actionResult", headerName: "Aksiyon Açıklaması", minWidth: 150, headerAlign: "center", align: "center", flex: 1 },
  ], [])

  const extendedColumns = useMemo(() => [
    
    
    { field: "deviceId", headerName: "Cihaz ID", minWidth: 180, headerAlign: "center", align: "center", flex: 1 },
    { field: "ipAddress", headerName: "IP Adresi", minWidth: 140, headerAlign: "center", align: "center", flex: 1, valueGetter: (params) => params.row.publicIp ?? params.row.ipAddress ?? '' },
    ...getExtraReportColumns(),
  ], [])

  const dataGrid_Columns_resolved = useMemo(
    () => (showExtra ? [...defaultColumns, ...extendedColumns] : defaultColumns),
    [showExtra, defaultColumns, extendedColumns]
  )


  return (
    <Box>

      <DataGrid
        columns={dataGrid_Columns_resolved}
        rows={tesekkur}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[10, 25, 50, 75, 100]}
        slots={{ toolbar: ExcelExportToolbar }}
        slotProps={{ toolbar: { reportName: 'Tesekkur', columns: dataGrid_Columns_resolved, showExtra } }}
        disableRowSelectionOnClick
        sx={{
          boxShadow: 4,
        }}
      />

      <ActionType_Modal handleClose_action={handleClose_action} open_action={open_action} info={info} setInfo={setInfo} />
      <Delete_Modal info={info} setInfo={setInfo} open_delete={open_delete} handleClose_delete={handleClose_delete} handleOpen_delete={handleOpen_delete} />

    </Box>
  )
}

export default Tesekkur_Table